import React, {PureComponent} from 'react';
import {Card, CardBody, Col} from 'reactstrap';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import DraftsHead from './Table/Head';
import Toolbar from './Table/Toolbar';
import {connect} from 'react-redux';
import {removePost, fetchPublishedPaginated, updatePost} from '../../../../../redux/actions/postsActions';
import {withRouter} from 'react-router-dom';
import moment from 'moment';
import Pagination from '../../../../../shared/components/pagination/Pagination';
import withErrorNotification from '../../../../../hof/withErrorNotification';
import {Posts} from '../../../../../services/Posts';
import Notifications from '../../../../../hof/notifications';
import {withTranslation} from "react-i18next";
import MoveToBlogButton from './Buttons/MoveToBlogButton';
import OpenArticleOnBlog from './Buttons/OpenArticleOnBlog';
import EditArticle from './Buttons/EditArticle';
import RemoveArticle from './Buttons/RemoveArticle';
import HideArticle from './Buttons/HideArticle';
import RevealArticle from './Buttons/RevealArticle';
import ConfirmRemoveModal from '../../../../Layout/modals/ConfirmRemoveModal';
import MoveArticleToBlogModal from './Modals/MoveArticleToBlogModal';

const defaultImage = `${process.env.PUBLIC_URL}/img/default.jpg`;

class PostsTable extends PureComponent {
    state = {
        order: 'desc',
        orderBy: 'publishedAt',
        selected: [],
        page: 1,
        rowsPerPage: 15,
        isConfirmationModalOpened: false,
        isMoveToAnotherBlogModalOpened: false,
        postIdToRemove: null,
        postIdToMove: null
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({order, orderBy});

        const blogId = this.props.blog._id;
        this.props.onFetchPosts(blogId, this.state.page, this.state.rowsPerPage, orderBy, order);
    };

    handleChangePage = (page) => {
        this.setState({page});
        const blogId = this.props.blog._id;
        this.props.onFetchPosts(blogId, page, this.state.rowsPerPage, this.state.orderBy, this.state.order);
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({rowsPerPage: event.target.value});
    };

    handleEditSelected = async (draftId) => {
        this.props.history.push(`/edit/${draftId}`);
    }

    handleConfirmationModalOpen = (postId) => {
        this.setState({isConfirmationModalOpened: true, postIdToRemove: postId});
    }

    handleDeleteSelected = async () => {

        const {t} = this.props;

        await withErrorNotification(async () => {
            const blogId = this.props.blog._id;
            await Posts.remove(this.state.postIdToRemove, blogId);
            this.props.onRemovePost(this.state.postIdToRemove);
            Notifications.showNotification(
                t('posts.articles.notifications.article_deleted.title'),
                t('posts.articles.notifications.article_deleted.body'),
                Notifications.Colors.SUCCESS);
            this.setState({isConfirmationModalOpened: false, postIdToRemove: null});
        }, () => {
            this.setState({isConfirmationModalOpened: false, postIdToRemove: null});
        })

    }

    handleConfirmationModalCancel = () => {
        this.setState({isConfirmationModalOpened: false, postIdToRemove: null});
    }

    openMoveModal = (postId) => {
        this.setState({isMoveToAnotherBlogModalOpened: true, postIdToMove: postId})
    }

    closeMoveModal = () => {
        this.setState({isMoveToAnotherBlogModalOpened: false, postIdToMove: null});
    }

    handleMoveToBlog = async (destBlogId, destCategoryId) => {

        const {t} = this.props;

        await withErrorNotification(async () => {
            const blogId = this.props.blog._id;
            await Posts.moveToBlog(this.state.postIdToMove, blogId, destBlogId, destCategoryId);
            this.props.onRemovePost(this.state.postIdToMove);
            Notifications.showNotification(
                t('posts.articles.notifications.article_moved.title'),
                t('posts.articles.notifications.article_moved.body'),
                Notifications.Colors.SUCCESS);
            this.closeMoveModal();
        }, () => {
           this.closeMoveModal();
        })

    }

    handleHideSelected = async (postId) => {

        const {t} = this.props;

        await withErrorNotification(async () => {
            const blogId = this.props.blog._id;
            const {post} = await Posts.hide(postId, blogId);
            this.props.onChangePost(post);
            Notifications.showNotification(
                t('posts.articles.notifications.article_hidden.title'),
                t('posts.articles.notifications.article_hidden.body'),
                Notifications.Colors.SUCCESS);
        })

    }

    handleUnhideSelected = async (postId) => {

        const {t} = this.props;

        await withErrorNotification(async () => {
            const blogId = this.props.blog._id;
            const {post} = await Posts.unhide(postId, blogId);
            this.props.onChangePost(post);
            Notifications.showNotification(
                t('posts.articles.notifications.article_revealed.title'),
                t('posts.articles.notifications.article_revealed.body'),
                Notifications.Colors.SUCCESS);
        })

    }

    createCategoriesNamesList = (ids) => {
        let categories = [];
        for (let id of ids) {
            for (let category of this.props.blog.categories) {
                if (category._id === id) {
                    categories.push(category.name);
                }
            }
        }
        return categories;
    }

    render() {
        const {
            order, orderBy, selected
        } = this.state;

        const {t} = this.props;

        return (
            <>
            <Col md={12} lg={12}>
                <Card>
                    <CardBody>
                        <div className="card__title">
                            <h5 className="bold-text">{t('posts.articles.title')}</h5>
                            <h5 className="subhead">{t('posts.articles.subtitle')}</h5>
                        </div>
                        {this.props.posts.length ? (
                            <>
                                <Toolbar
                                    numSelected={selected.length}
                                    handleScheduleSelected={this.handleScheduleSelected}
                                    onRequestSort={this.handleRequestSort}
                                />
                                <div className="material-table__wrap">
                                    <Table className="material-table">
                                        <DraftsHead
                                            numSelected={selected.length}
                                            order={order}
                                            orderBy={orderBy}
                                            // onSelectAllClick={this.handleSelectAllClick}
                                            onRequestSort={this.handleRequestSort}
                                            rowCount={this.props.posts.length}
                                        />
                                        <TableBody>
                                            {this.props.posts
                                                .map((d) => {
                                                    return (
                                                        <TableRow
                                                            className="material-table__row"
                                                            role="checkbox"
                                                            tabIndex={-1}
                                                            key={d._id}
                                                        >
                                                            <TableCell className="material-table__cell"
                                                                       padding="checkbox">
                                                                <div className="draft_table-img-wrapper">
                                                                    <img className="draft_table-img"
                                                                         src={d.thumbnail_image ? d.thumbnail_image : defaultImage}
                                                                         alt=""/>
                                                                </div>
                                                            </TableCell>
                                                            <TableCell
                                                                className="material-table__cell"
                                                                component="td"
                                                                scope="row"
                                                                padding="none">
                                <span>
                                  {d.title}
                                </span>
                                                            </TableCell>
                                                            <TableCell className="material-table__cell">
                                                                {this.createCategoriesNamesList(d.categories).map(category =>
                                                                    <span className="tag"
                                                                          key={category}>{category}</span>)}
                                                            </TableCell>
                                                            <TableCell className="material-table__cell">
                                                                {d.tags.map(tag => <span className="tag"
                                                                                         key={tag}>{tag}</span>)}
                                                            </TableCell>
                                                            <TableCell
                                                                className="material-table__cell">{d.username}</TableCell>
                                                            <TableCell
                                                                className="material-table__cell">{moment(d.publishedAt).format('llll')}</TableCell>
                                                            <TableCell
                                                                className="material-table__cell material-table__cell-actions">
                                                                {d.hidden && d.username === this.props.auth.username && <RevealArticle onClick={() => this.handleUnhideSelected(d._id)} />}
                                                                {!d.hidden && d.username === this.props.auth.username && <HideArticle onClick={() => this.handleHideSelected(d._id)} />}
                                                                {!d.hidden && d.username === this.props.auth.username && <RemoveArticle onClick={() => this.handleConfirmationModalOpen(d._id)} />}
                                                                {!d.hidden && d.username === this.props.auth.username && <EditArticle onClick={() => this.handleEditSelected(d._id)} />}
                                                                {!d.hidden && d.username === this.props.auth.username && <MoveToBlogButton onClick={() => this.openMoveModal(d._id)} />}
                                                                {!d.hidden && <OpenArticleOnBlog onClick={() => window.open(`https://${this.props.blog.domain}/${d.permlink}`, '_blank')} />}
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })}

                                        </TableBody>
                                    </Table>
                                </div>
                                <Pagination
                                    itemsCount={this.props.metadata.total}
                                    itemsToShow={this.props.metadata.limit}
                                    pageOfItems={this.props.metadata.page + 1}
                                    onChangePage={this.handleChangePage}
                                /></>) : <p>{t('posts.articles.no_articles_found')}</p>}
                    </CardBody>
                </Card>
            </Col>
                <ConfirmRemoveModal
                    onAccept={() => this.handleDeleteSelected()}
                    onClose={() => this.handleConfirmationModalCancel()}
                    isOpen={this.state.isConfirmationModalOpened} />
                <MoveArticleToBlogModal
                    blogs={this.props.blogs.filter(blog => blog._id !== this.props.blog._id)}
                    onClose={() => this.closeMoveModal()}
                    onSubmit={(destBlogId, destCategoryId) => {
                        return this.handleMoveToBlog(destBlogId, destCategoryId);
                    }}
                    isOpen={this.state.isMoveToAnotherBlogModalOpened} />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        posts: state.posts.data,
        metadata: state.posts.metadata,
        blog: state.blogs.blog,
        blogs: state.blogs.blogs,
        auth: state.auth
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onRemovePost: (postId) => {
            dispatch(removePost(postId))
        },
        onChangePost: (post) => {
            dispatch(updatePost(post))
        },
        onFetchPosts: (blogId, page, limit, sortBy, order) => {
            dispatch(fetchPublishedPaginated(blogId, page, limit, sortBy, order))
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation('dashboard')(PostsTable)));
